// import { Icon } from "@chakra-ui/icons";
import {
  Flex,
  useColorModeValue,
  Text,
  Stack,
  Icon,
  Heading,
  Input,
  Button,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { FaUnlockAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { forgotPassword } from "../../../redux/actions/user/UserActions";
import { RootStore } from "../../../redux/Store";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [errorsMsg, setErrorsMsg] = useState("");
  const [emailClickState, setEmailClickState] = useState(false);
  const userState = useSelector((state: RootStore) => state.user);
  const dispatch = useDispatch();
  const handleSubmit = () => {
    setEmailClickState(true);
    if (validation() && emailPatternValidation()) {
      console.log(email);
      dispatch(forgotPassword(email));
    }
  };
  const validation = (): boolean => {
    let isValid = true;

    if (!email) {
      if (!email) {
        setErrorsMsg("This field must not be empty");
        isValid = false;
      }
    }

    return isValid;
  };
  const emailPatternValidation = (): boolean => {
    let isValid = true;
    if (email) {
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (!pattern.test(email)) {
        isValid = false;
      }
    }
    return isValid;
  };
  return (
    <>
      <Flex minH={"80vh"} align={"center"} justify={"center"} py={12}>
        <Stack
          boxShadow={"2xl"}
          bg={useColorModeValue("gray.50", "gray.800")}
          rounded={"xl"}
          p={10}
          spacing={8}
          align={"center"}
        >
          <Icon as={FaUnlockAlt} color="black" w={24} h={24} />
          <Stack align={"center"} spacing={2}>
            <Heading
              textTransform={"uppercase"}
              textAlign="center"
              fontSize={"3xl"}
              color={"black"}
            >
              Forgot Password ?
            </Heading>
            <Text fontSize={"sm"} color={"#D10024"} textAlign="center">
              😯 Well, that's no fun.
            </Text>
            <Text fontSize={"lg"} color={"black"} textAlign="center">
              Provide your email address.
              <Text>We will send you a link to reset your password.</Text>
            </Text>
          </Stack>
          <Stack
            spacing={4}
            direction={{ base: "column", md: "row" }}
            w={"full"}
          >
            <Input
              id="forgotEmail"
              name="forgotEmail"
              type={"text"}
              value={email}
              placeholder={"e.g. good@regime.com"}
              color="black"
              bg={"white"}
              onChange={(event) => setEmail(event.target.value)}
              rounded={"full"}
              border={0}
              required
              _focus={{
                bg: useColorModeValue("gray.200", "gray.800"),
                outline: "none",
              }}
            />

            <Button
              id="SendButton"
              name="SendButton"
              bg={"blue.400"}
              rounded={"full"}
              onClick={handleSubmit}
              color={"white"}
              flex={"1 0 auto"}
              _hover={{ bg: "blue.500" }}
              _focus={{ bg: "blue.500" }}
            >
              Send Link
            </Button>
          </Stack>
          {emailClickState && (
            <Text
              style={{ marginTop: "20px" }}
              fontSize="sm"
              color="red"
              marginTop="3px"
            >
              {!email
                ? errorsMsg
                : !emailPatternValidation() &&
                  "Please enter a valid email address"}
            </Text>
          )}
          {userState.forgotResetPassword?.message && (
            <Text style={{ marginTop: "20px" }} fontSize="sm" color="red">
              {userState.forgotResetPassword.message}
            </Text>
          )}
          <Text fontSize={"sm"} color={"black"} textAlign="center">
            Heads up! You may need to check your spam folder or unblock
            <Text>regimegood@gmail.com.</Text>
          </Text>
        </Stack>
      </Flex>
    </>
  );
}

export default ForgotPassword;
